/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/* @relayHash 6f7a7d58672d2be5693925e421dd408a */

import { ConcreteRequest } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type GetOnTheRoadUberQueryVariables = {};
export type GetOnTheRoadUberQueryResponse = {
    readonly viewer: {
        readonly " $fragmentRefs": FragmentRefs<"PromotionsLayout_viewer" | "PrivateHireQuickEstimatesForm_viewer">;
    };
};
export type GetOnTheRoadUberQuery = {
    readonly response: GetOnTheRoadUberQueryResponse;
    readonly variables: GetOnTheRoadUberQueryVariables;
};



/*
query GetOnTheRoadUberQuery {
  viewer {
    ...PromotionsLayout_viewer
    ...PrivateHireQuickEstimatesForm_viewer
  }
}

fragment PrivateHireQuickEstimatesForm_viewer on Viewer {
  currentUser {
    fullName
    id
  }
}

fragment PromotionsLayout_viewer on Viewer {
  ...SessionLayout_viewer
}

fragment SessionLayout_viewer on Viewer {
  session {
    id
    token
    expiresAt
  }
  currentUser {
    fullName
    customerNumber
    id
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "GetOnTheRoadUberQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "PromotionsLayout_viewer",
            "args": null
          },
          {
            "kind": "FragmentSpread",
            "name": "PrivateHireQuickEstimatesForm_viewer",
            "args": null
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "GetOnTheRoadUberQuery",
    "argumentDefinitions": [],
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "session",
            "storageKey": null,
            "args": null,
            "concreteType": "Session",
            "plural": false,
            "selections": [
              (v0/*: any*/),
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "token",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "expiresAt",
                "args": null,
                "storageKey": null
              }
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "currentUser",
            "storageKey": null,
            "args": null,
            "concreteType": "User",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "fullName",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "customerNumber",
                "args": null,
                "storageKey": null
              },
              (v0/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "GetOnTheRoadUberQuery",
    "id": null,
    "text": "query GetOnTheRoadUberQuery {\n  viewer {\n    ...PromotionsLayout_viewer\n    ...PrivateHireQuickEstimatesForm_viewer\n  }\n}\n\nfragment PrivateHireQuickEstimatesForm_viewer on Viewer {\n  currentUser {\n    fullName\n    id\n  }\n}\n\nfragment PromotionsLayout_viewer on Viewer {\n  ...SessionLayout_viewer\n}\n\nfragment SessionLayout_viewer on Viewer {\n  session {\n    id\n    token\n    expiresAt\n  }\n  currentUser {\n    fullName\n    customerNumber\n    id\n  }\n}\n",
    "metadata": {}
  }
};
})();
(node as any).hash = 'f4af621f8177fccd8b5fa3f9bbd03cc7';
export default node;
